import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-absent-block',
  standalone: true,
  imports: [],
  templateUrl: './absent-block.component.html',
  styleUrl: './absent-block.component.css'
})
export class AbsentBlockComponent {
  @Input() blockName: string;
}
